import { render, staticRenderFns } from "./data-empty.vue?vue&type=template&id=11d89842&"
import script from "./data-empty.vue?vue&type=script&lang=js&"
export * from "./data-empty.vue?vue&type=script&lang=js&"
import style0 from "./data-empty.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports